import "./trend-graph-chip.scss";
import "@/features/zone-overview/full-size-zone-overview/zone-overview-utility.css";

import TimelineIcon from "@mui/icons-material/Timeline";
import { Typography } from "@mui/material";
import * as React from "react";
import { generateUID } from "verdi-common/utils/HelperFunctions";
import { isValidNum } from "verdi-common/utils/mathUtils";
import { EventHandler } from "verdi-web-client";

import { DynamicGraphContext } from "@/features/dynamic-graph/dynamic-graph-utility";
import TypographyWithMaxWidth from "@/components/typography-with-max-width/typography-with-max-width";

export default class TrendGraphChip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            iconName: TimelineIcon,
            iconColor: this.props.sensor.color,
            label: "Trend",
        };
        this.uid = generateUID("trendgraphChip");
    }

    componentDidMount() {
        if (this.props.sensor.sensorType in this.context.staticGraphDictionary) {
            this.setState({
                unit: this.context.staticGraphDictionary[this.props.sensor.sensorType].unit,
                iconName: this.context.staticGraphDictionary[this.props.sensor.sensorType].iconName || TimelineIcon,
                iconColor: this.props.sensor.color, // staticGraphDictionary[this.props.sensor.sensorType].iconColor,
                label: this.context.staticGraphDictionary[this.props.sensor.sensorType].labelName,
                lastData: this.props.sensor.lastDataPoint,
            });
        }
        this.context.onFocusedLinesChanged.addListener(() => {
            this.forceUpdate();
        }, this.uid);
    }

    componentWillUnmount() {
        EventHandler.disposeOfAllHooksForUID(this.uid);
    }

    render() {
        const style = {};
        const rgbColor = hexToRgb(this.state.iconColor);
        style["--dataColor"] = `${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}`;

        let focused = false;
        if (this.context.lines[this.props.lineID].focused) {
            focused = true;
        }

        const lastDataValue = this.state?.lastData?.value;
        const sensorName = this.props.sensor.name || "Probe";
        const sensorNameLength = sensorName.length;
        const fontSize = sensorNameLength > 7 ? 7 : 10;
        const IconName = this.state.iconName;

        return (
            <>
                <div
                    style={style}
                    className={`DynamicGraphDataChip DynamicGraphDataChip--${focused ? "focused" : "unfocused"}`}
                    onClick={(e) => {
                        this.context.activeDataType = this.props.sensor.sensorType;
                        this.context.onActiveDataTypeChanged.trigger();

                        // Single-click toggles this line's focus; double-click also spotlights/unfocuses other lines.
                        const isDoubleClick = e.detail % 2 === 0;
                        this.context.toggleLineFocus(this.props.lineID, isDoubleClick);
                    }}
                >
                    <div className={"ChipTitleWrapper"} title={this.props?.sensor?.name || "Probe"}>
                        <Typography variant={"button"} className={"ChipTitle"} style={{ fontSize: fontSize }}>
                            {this.props.sensor.name || "Probe"}
                        </Typography>
                    </div>
                    <div className={"DynamicGraphDataChip--Body"}>
                        <div className={"DynamicGraphDataChipIconAndCurValue"}>
                            <div className={"ChipIconWrapper"}>
                                <IconName slim={true} className={"DynamicGraphDataChipIcon"} />
                            </div>

                            <div className={"DynamicGraphDataChipCurValue"}>
                                <TypographyWithMaxWidth
                                    MaxWidth={55 / 2 - 3}
                                    variant={"button"}
                                    className={"ChipValue"}
                                >
                                    {isValidNum(lastDataValue)
                                        ? this.context.staticGraphDictionary[
                                              this.props.sensor.sensorType
                                          ].labelForValue(lastDataValue)
                                        : "N/A"}
                                </TypographyWithMaxWidth>
                                <Typography variant={"button"} className={"ChipUnit"}>
                                    {this.state.unit || "N/A"}
                                </Typography>
                            </div>
                        </div>
                        <Typography variant={"button"} className={"ChipSensor"}>
                            {this.state.label || "None"}
                        </Typography>
                    </div>
                </div>
                {/* <Chip */}
                {/*    className={"zoneOverviewStatusChipStyle"} */}
                {/*    sx={{ */}
                {/*        backgroundColor: this.props.sensor.visible ? "rgba(0, 0, 0, 0.11)" : "#ffffff", */}
                {/*        "& .MuiChip-icon": { color: this.state.iconColor }, */}
                {/*    }} */}
                {/*    // disableRipple */}
                {/*    icon={<this.state.iconName />} */}
                {/*    label={this.state.label + ": " + (this.props.sensor.name || "Sensor")} */}
                {/*    size={"small"} */}
                {/*    variant={"outlined"} */}
                {/*    onClick={() => { */}
                {/*        this.context.activeDataType = this.props.sensor.sensorType; */}
                {/*        this.context.onActiveDataTypeChanged.trigger(); */}
                {/*    }} */}
                {/*    onDelete={this.props.onDelete} */}
                {/* /> */}
            </>
        );
    }
}

TrendGraphChip.contextType = DynamicGraphContext;
function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
}
//
// TrendGraphChip.propTypes = {
//     lineID: PropTypes.string,
//     sensor: PropTypes.object,
//     onDelete: PropTypes.func,
// };
